import styled from 'styled-components';
import { string, shape, func, bool, array } from 'prop-types';

import StyledIcon from './StyledIcon';
import StyledText from '../shared/StyledText';
import { MAIN_COLOR } from '../../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: ${({ hasHover }) => (hasHover ? 'pointer' : null)};
  transition: all 0.2s ease;
  ${({ isSelected }) =>
    isSelected &&
    `
      div {
        border-color: ${MAIN_COLOR};
        color: ${MAIN_COLOR};
      }

      svg {
        color: ${MAIN_COLOR};
      }
    `}

    :hover {
      ${({ hasHover }) =>
        hasHover &&
        `
        div {
          border-color: ${MAIN_COLOR};
          color: ${MAIN_COLOR};
        }

        svg {
          color: ${MAIN_COLOR};
        }
      `}
    }

    @media (max-width: 400px) {
      margin-bottom: 15px;
    }


  }
`;

const IconContainer = styled.div`
  align-items: center;
  border-radius: 100%;
  border: 2px solid ${({ color }) => color};
  display: flex;
  height: 60px;
  justify-content: center;
  width: 60px;
  margin: ${({ margin }) => margin};
`;

const CircleIcon = ({
  color,
  margin,
  hasHover,
  isSelected,
  label,
  onClick,
  ...args
}) => {
  const renderIcon = () => (
    <IconContainer color={color} margin={margin}>
      <StyledIcon color={color} {...args} />
    </IconContainer>
  );

  if (label) {
    return (
      <Container onClick={onClick} isSelected={isSelected} hasHover={hasHover}>
        {renderIcon()}
        <StyledText margin="10px 0 0 0" textAlign="center">
          {label}
        </StyledText>
      </Container>
    );
  }

  return <Container hasHover={hasHover}>{renderIcon()}</Container>;
};

CircleIcon.propTypes = {
  color: string.isRequired,
  icon: shape({
    prefix: string.isRequired,
    iconName: string.isRequired,
    icon: array.isRequired,
  }).isRequired,
  size: string.isRequired,
  margin: string,
  label: string,
  hasHover: bool,
  onClick: func,
  isSelected: bool,
};

export default CircleIcon;



// WEBPACK FOOTER //
// components/shared/CircleIcon.js